module.exports = __webpack_public_path__ + "static/media/HeroImage.ca400b85.jpg";